import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { AppState } from '../../../../../../core/reducers';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import {
  AffiliationsService,
  Doctor,
  DoctorOnServerCreated,
  DoctorOnServerUpdated,
  DoctorService,
  selectDoctorsActionLoading,
  selectErrorState,
  selectLastCreatedDoctor,
  SharedHttpRequestService,
  NoteEntityType,
} from '../../../../../../core/lists';
import { currentUser, currentUserPermissions } from 'src/app/core/auth';
import { TranslateService } from '@ngx-translate/core';
import { tagsViewContext } from '../../../../../../core/lists/_services/shared-http-request.service';
import { OfficesService } from '../../../../../../core/management';
import { GeneralAutocompleteComponent } from '../../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { GeneralValidationMessagesService } from '../../../../../../core/services/general-validation-messages.service';
import { SpecialtyService } from '../../../../../../core/lists/_services/specialty.service';
import { uniqWith, isEqual } from 'lodash-es';
import OpenLocationCode from 'open-location-code-typescript';
import { MapsAPILoader } from '@agm/core';
import { take } from 'rxjs/operators';
import { GlobalSettingsService } from '../../../../../../core/services/global-settings.service';
import { TitleCasePipe } from '@angular/common';
import { ZoomInEntityComponent } from '../../../../../partials/content/general/zoom-in-entity/zoom-in-entity.component';
import { NavigationService } from '../../../../../../core/services/navigation.service';
import { PictureCropperComponent } from '../../../../../partials/content/general/picture-cropper/picture-cropper.component';
import { ImageSettingService } from '../../../../../../core/services/image-setting.service';

@Component({
  selector: 'kt-doctor-edit',
  templateUrl: './doctor-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./doctor-edit.component.scss'],
})
export class DoctorEditComponent implements OnInit, OnDestroy {
  // for HTML template use
  NoteEntityType = NoteEntityType;
  //
  geocoder;
  params: any;
  lat = null;
  lng = null;
  doctor: Doctor;
  oldDoctor: Doctor;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  doctorForm: FormGroup;
  hasFormErrors = false;
  private headerMargin: number;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  private subscriptions: any[] = [];
  tags = new FormControl();
  tags$ = new BehaviorSubject<any>([]);
  tagsArr = [];
  @ViewChild('autocompleteComponent') autocompleteComponent: GeneralAutocompleteComponent;
  specialtiesAutocompleteCall = this.specialtyService.searchProviderTypes.bind(
    this.specialtyService,
    '&primary=true',
  );
  @ViewChild('specialtiesAutocomplete') specialtiesAutocomplete: GeneralAutocompleteComponent;
  subspecialitiesAutocompleteCall = this.specialtyService.searchProviderTypes.bind(
    this.specialtyService,
    '&primary=false',
  );
  @ViewChild('subspecialitiesAutocomplete')
  subspecialitiesAutocomplete: GeneralAutocompleteComponent;
  isViewMode: boolean;
  officeAutocompleteCall = this.officesService.searchOffices.bind(this.officesService);
  readOnly = false;
  urbanizationValue;
  Address1Value;
  Address2Value;
  cityValue;
  zipValue;
  @Input() entity_id;
  @Input() fromCanvas;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() focusedViewOpen = new EventEmitter<any>();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() navigateToContact = new EventEmitter<any>();
  @Output() navigateToPatient = new EventEmitter<any>();
  doctorProfile;
  newAvatar = null;
  private needToChangeImage = false;
  basicInfo: any = {};
  needToChange = false;
  doctorFemaleDefault = '/assets/media/doctors/doctorFemale.svg';
  doctorMaleDefault = '/assets/media/doctors/doctorMale.svg';
  doctorUndefinedDefault = '/assets/media/doctors/doctorUndefined.svg';
  tabs = [
    { index: 0, label: 'General Info', icon: 'mat-tab-label-icon fa fa-info', active: true },
    {
      index: 1,
      label: 'Relations',
      icon: 'mat-tab-label-icon fas fa-people-arrows',
      active: false,
      permission: 'canViewRelation',
    },
    {
      index: 2,
      label: 'Notes',
      icon: 'flaticon-notes icon-md',
      active: false,
      permission: 'canViewNote',
    },
    {
      index: 3,
      label: 'Patients',
      icon: 'mat-tab-label-icon fas fa-hospital-user',
      active: false,
      permission: 'canViewPatient',
    },
    {
      index: 4,
      label: 'Other Details',
      icon: 'mat-tab-label-icon fas fa-ellipsis-h',
      active: false,
    },
    {
      index: 5,
      label: 'Sales Teams',
      icon: 'mat-tab-label-icon icon-lg fas flaticon-network',
      active: false,
      permission: 'accessToSalesTeamsModule',
    },
    {
      index: 6,
      label: 'Tasks',
      icon: 'mat-tab-label-icon fas fa-tasks',
      active: false,
      permission: 'accessToTaskModule',
    },
    {
      index: 7,
      label: 'Documents',
      icon: 'mat-tab-label-icon icon-lg fa fa-file-alt',
      active: false,
    },
    {
      index: 8,
      label: 'Affiliations',
      icon: 'mat-tab-label-icon icon-lg fa fa-handshake',
      active: false,
    },
  ];
  loadingData = false;
  entity_id_param;
  entity_type_param;
  officeOptionFormatter = (val) => (val && val.name ? val.name : '');

  constructor(
    private navigationService: NavigationService,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private doctorFB: FormBuilder,
    private layoutUtilsService: LayoutUtilsService,
    private doctorService: DoctorService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private sharedHttpRequestService: SharedHttpRequestService,
    public dialog: MatDialog,
    private officesService: OfficesService,
    private affiliationsService: AffiliationsService,
    private globalService: GeneralValidationMessagesService,
    private specialtyService: SpecialtyService,
    private mapsAPILoader: MapsAPILoader,
    private globalSettings: GlobalSettingsService,
    private titleCasePipe: TitleCasePipe,
    private imageSettingService: ImageSettingService,
  ) {
    this.mapsAPILoader.load().then(() => {
      this.geocoder = new google.maps.Geocoder();
    });
  }
  closeDialog(e) {
    if (e) {
      this.focusedViewOpen.emit(true);
      this.navigateToContact.emit(true);
      this.navigateToPatient.emit(true);
    }
  }
  ngOnInit() {
    // Load Doctor from @Input()
    if (this.entity_id) {
      this.globalService.getEntitiesById('doctors', this.entity_id).subscribe((res) => {
        if (res) {
          this.loadDoctor(res.data);
          this.cdr.detectChanges();
        }
      });
      return;
    }

    // this line due to make the navigation service return to doctor list if there is no ->
    // navigation stack saved before in special cases
    this.navigationService.setDefaultRoot('/lists/doctors');

    this.activatedRoute.queryParams.subscribe((params) => {
      params.tab_index ? this.changeTab(+params.tab_index) : this.changeTab(0);
    });
    const userSub = this.store.pipe(select(currentUser)).subscribe((res) => {
      if (!res) {
        this.goBack();
      }
    });
    this.subscriptions.push({ id: 1, sub: userSub });
    this.loading$ = this.loadingSubject.asObservable();
    this.loadingSubject.next(true);
    const routeSub = this.activatedRoute.params.subscribe((params) => {
      const id = params.id;
      // Exist Doctor , Edit mode.
      if (id && id > 0) {
        const doctorById = this.globalService.getEntitiesById('doctors', id).subscribe((res) => {
          if (res) {
            this.loadDoctor(res.data);
            this.loadTags();
            this.cdr.detectChanges();
            return;
          }
        });
        this.subscriptions.push({ id: 2, sub: doctorById });
      } else {
        // Not exist Doctor, Create mode.
        const newDoctor = new Doctor();
        newDoctor.clear();
        this.loadDoctor(newDoctor);
      }
    });
    this.subscriptions.push({ id: 3, sub: routeSub });
    window.onload = () => {
      const style = getComputedStyle(document.getElementById('kt_header'));
      this.headerMargin = parseInt(style.height, 0);
    };
  }

  private loadTags() {
    this.sharedHttpRequestService
      .getTagsForView(this.doctor.id, tagsViewContext.ENTITIES)
      .subscribe((tags) => {
        this.tags$.next(tags.data);
        this.tagsArr = tags.data;
      });
  }

  loadDoctor(_doctor) {
    if (!_doctor) {
      this.goBack();
      return;
    }
    this.doctor = _doctor;
    this.oldDoctor = Object.assign({}, _doctor);
    this.initDoctor();
    this.basicInfo = {
      avatar: this.doctor.pre_signed_url?.url
        ? this.doctor.pre_signed_url.url
        : this.doctor.gender
        ? this.doctor.gender === 'FEMALE'
          ? this.doctorFemaleDefault
          : this.doctorMaleDefault
        : this.doctorUndefinedDefault,
    };
    this.doctorProfile = this.basicInfo.avatar
      ? this.basicInfo.avatar
      : this.doctorUndefinedDefault;
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  initDoctor() {
    this.createForm();
    this.loadingSubject.next(false);
    if (!this.doctor.id) {
      this.isViewMode = false;
    } else if (!this.entity_id && this.activatedRoute.url[`_value`][1]?.path === 'view') {
      this.readOnly = true;
      this.isViewMode = true;
      this.doctorForm.disable();
      this.doctorForm.controls.geolocation_address.enable();
    } else {
      this.subscriptions.push(
        this.store.pipe(select(currentUserPermissions)).subscribe((res) => {
          if (!res.some((p) => p.name === 'canEditDoctor')) {
            this.readOnly = true;
          }
        }),
      );
      this.isViewMode = false;
    }
  }

  createForm() {
    let specialtiesthis = [];
    let subspecialities = [];
    if (this.doctor.id) {
      specialtiesthis = this.doctor.provider_types.filter((e) => e.primary);
      subspecialities = this.doctor.provider_types.filter((e) => !e.primary);
    }
    this.doctorForm = this.doctorFB.group({
      practice_name: [this.doctor.practice_name],
      first_name: [this.doctor.first_name, Validators.required],
      last_name: [this.doctor.last_name, Validators.required],
      middle_name: [this.doctor.middle_name],
      last_name2: [this.doctor.last_name2],
      gender: [this.doctor.gender ? this.doctor.gender : ''],
      email: [this.doctor.email, Validators.compose([Validators.email])],
      city: [this.doctor.city, Validators.compose([Validators.required, Validators.maxLength(30)])],
      state: [this.doctor.state, Validators.required],
      address_1: [
        this.doctor.address_1,
        Validators.compose([Validators.required, Validators.maxLength(48)]),
      ],
      address_2: [this.doctor.address_2, Validators.maxLength(48)],
      is_active: [this.doctor.is_active],
      zip: [
        this.doctor.zip,
        Validators.compose([Validators.required, Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)]),
      ],
      office_phone: [
        this.doctor.office_phone !== '' && this.doctor.office_phone !== null
          ? '(' +
            this.doctor.office_phone.substring(0, 3) +
            ') ' +
            this.doctor.office_phone.substring(3, 6) +
            '-' +
            this.doctor.office_phone.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      cell_phone: [
        this.doctor.cell_phone !== '' && this.doctor.cell_phone !== null
          ? '(' +
            this.doctor.cell_phone.substring(0, 3) +
            ') ' +
            this.doctor.cell_phone.substring(3, 6) +
            '-' +
            this.doctor.cell_phone.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      fax: [
        this.doctor.fax !== '' && this.doctor.fax !== null
          ? '(' +
            this.doctor.fax.substring(0, 3) +
            ') ' +
            this.doctor.fax.substring(3, 6) +
            '-' +
            this.doctor.fax.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      office_id: [null],
      dea: [this.doctor.dea],
      npi: [this.doctor.npi],
      sln: [this.doctor.sln],
      urbanization: [this.doctor.urbanization, Validators.maxLength(48)],
      note: [this.doctor.note],
      doctor_id: [this.doctor.doctor_id, [Validators.pattern(/^[A-Za-z0-9]+$/)]],
      last_modified_user: [this.doctor.last_modified_user],
      latitude: [{ value: this.doctor.latitude ? this.doctor.latitude : null, disabled: true }],
      longitude: [{ value: this.doctor.longitude ? this.doctor.longitude : null, disabled: true }],
      plus_code: [{ value: this.doctor.plus_code, disabled: true }],
      geolocation_address: [this.doctor.geolocation_address],
      specialties: [specialtiesthis],
      subspecialities: [subspecialities],
      extension: [this.doctor.extension],
    });
    if (this.doctor.id > 0) {
      this.doctorForm.controls.specialties.setValue(specialtiesthis);
      this.doctorForm.controls.subspecialities.setValue(subspecialities);
      if (this.doctor?.office_id) {
        this.officesService.getOfficeById(this.doctor.office_id).subscribe((res) => {
          this.doctorForm.controls.office_id.setValue(res);
          this.autocompleteComponent?.setValue(res);
        });
      }
      this.urbanizationValue = this.doctor.urbanization;
      this.Address1Value = this.doctor.address_1;
      this.Address2Value = this.doctor.address_2;
      this.cityValue = this.doctor.city;
      this.zipValue = this.doctor.zip;
    }
    if (
      (!this.doctor?.latitude || !this.doctor?.longitude) &&
      !this.doctor.geolocation_address &&
      this.doctor?.plus_code
    ) {
      const area = OpenLocationCode.decode(this.doctorForm.get('plus_code').value);
      this.setCoordinates(area.latitudeCenter, area.longitudeCenter);
      setTimeout(() => {
        this.setGeolocationAddress(area.latitudeCenter, area.longitudeCenter);
      }, 2500);
    }
    if (
      this.doctor?.latitude &&
      this.doctor?.longitude &&
      !this.doctor?.plus_code &&
      !this.doctor?.geolocation_address
    ) {
      this.setCoordinates(this.doctor.latitude, this.doctor.longitude);
      this.setGeolocationAddress(this.doctor.latitude, this.doctor.longitude);
      setTimeout(() => {
        this.setGeolocationAddress(this.doctor.latitude, this.doctor.longitude);
      }, 2500);
      this.doctorForm
        .get('plus_code')
        .setValue(OpenLocationCode.encode(this.doctor.latitude, this.doctor.longitude));
    }
    this.loadingData = true;
  }

  markerDragEnd($event: any) {
    this.setCoordinates($event.latLng.lat(), $event.latLng.lng());
    this.setGeolocationAddress(this.lat, this.lng);
  }

  setCoordinates(lat, lng) {
    this.doctorForm.get('latitude').setValue(lat);
    this.doctorForm.get('longitude').setValue(lng);
    this.lng = lng;
    this.lat = lat;
    this.cdr.detectChanges();
  }

  setGeolocationAddress(lat, lng) {
    const latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };
    this.geocoder?.geocode({ location: latLng }, (response: any) => {
      if (response && response[0]) {
        this.doctorForm
          .get('geolocation_address')
          .setValue(response && response[0]?.formatted_address);
      } else {
        window.alert('No results found');
      }
    });
  }

  resetGeolocation() {
    this.doctorForm.get('geolocation_address').setValue(null);
    this.doctorForm.get('plus_code').setValue(null);
    this.doctorForm.get('latitude').setValue(null);
    this.doctorForm.get('longitude').setValue(null);
  }
  searchForGeolocation() {
    this.globalSettings
      .getPlusCode(this.doctorForm.get('geolocation_address').value)
      .subscribe((res) => {
        if (res.status === 'OK' || res.status === 'ok') {
          this.doctor.geolocation_address = this.doctorForm.get('geolocation_address').value;
          this.doctor.plus_code = res?.plus_code?.global_code;
          this.doctor.latitude = res?.plus_code?.geometry?.location?.lat;
          this.doctor.longitude = res?.plus_code?.geometry?.location?.lng;
          this.doctorForm.get('plus_code').setValue(res?.plus_code?.global_code);
          this.doctorForm.get('latitude').setValue(res?.plus_code?.geometry?.location?.lat);
          this.doctorForm.get('longitude').setValue(res?.plus_code?.geometry?.location?.lng);
          return;
        }
        const message = 'We could not find: ' + this.doctorForm.get('geolocation_address').value;
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Read,
          3000,
          true,
          false,
        );
      });
  }

  goBack() {
    if (this.entity_id) return;
    this.loadingSubject.next(false);
    this.navigationService.goBack();
  }

  reset() {
    this.doctor = Object.assign({}, this.oldDoctor);
    this.createForm();
    this.hasFormErrors = false;
    this.doctorForm.markAsPristine();
    this.doctorForm.markAsUntouched();
    this.doctorForm.updateValueAndValidity();
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.doctorForm.controls;
    if (this.doctorForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      this.changeTab(0);
      return;
    }
    const editedDoctor = this.prepareDoctor();
    if (editedDoctor.id > 0) {
      this.updateDoctor(editedDoctor);
      return;
    }
    this.addDoctor(editedDoctor);
  }

  prepareDoctor(): Doctor {
    const controls = this.doctorForm.controls;
    const _doctor = new Doctor();
    _doctor.clear();
    _doctor.dea = controls.dea.value;
    _doctor.address_1 = controls.address_1.value;
    _doctor.address_2 = controls.address_2.value;
    _doctor.npi = controls.npi.value;
    _doctor.sln = controls.sln.value;
    _doctor.office_id = controls.office_id.value ? controls.office_id.value.id : 0;
    _doctor.id = this.doctor.id;
    _doctor.practice_name = controls.practice_name.value;
    _doctor.first_name = controls.first_name.value;
    _doctor.last_name = controls.last_name.value;
    _doctor.middle_name = controls.middle_name.value;
    _doctor.last_name2 = controls.last_name2.value;
    _doctor.email = controls.email.value;
    _doctor.gender = controls.gender.value ? controls.gender.value : null;
    _doctor.office_phone =
      controls.office_phone.value !== null
        ? controls.office_phone.value.replace(/\D/g, '')
        : controls.office_phone.value;
    _doctor.zip = controls.zip.value;
    _doctor.cell_phone =
      controls.cell_phone.value !== null
        ? controls.cell_phone.value.replace(/\D/g, '')
        : controls.cell_phone.value;
    _doctor.is_active = controls.is_active.value;
    _doctor.fax =
      controls.fax.value !== null ? controls.fax.value.replace(/\D/g, '') : controls.fax.value;
    _doctor.city = controls.city.value;
    _doctor.urbanization = controls.urbanization.value;
    _doctor.state = controls.state.value ? controls.state.value.toUpperCase() : '';
    _doctor.note = controls.note.value;
    _doctor.doctor_id = controls.doctor_id.value ? controls.doctor_id.value : '';
    _doctor.last_modified_user = controls.last_modified_user.value;
    _doctor.tags = this.tags.value;
    _doctor.plus_code = controls.plus_code.value;
    _doctor.latitude = controls.latitude.value;
    _doctor.geolocation_address = controls.geolocation_address.value;
    _doctor.extension = controls.extension.value;
    _doctor.longitude = controls.longitude.value;
    if (controls.specialties.value) {
      _doctor.provider_types = controls.specialties.value.concat(controls.subspecialities.value);
    }
    if (this.needToChangeImage || this.needToChange) {
      _doctor.avatar = this.basicInfo.avatarUUID;
    } else {
      _doctor.avatar = this.doctor.avatar;
    }
    for (const [key, value] of Object.entries(_doctor)) {
      if (typeof value === 'string') {
        _doctor[key] = value.trim();
      }
    }
    return _doctor;
  }

  addDoctor(_doctor: Doctor) {
    this.loadingSubject.next(true);
    this.store.dispatch(new DoctorOnServerCreated({ doctor: _doctor }));
    if (this.subscriptions.find((sub) => sub.id === 4) === undefined) {
      const actionLoadingSubscription = this.store
        .pipe(select(selectDoctorsActionLoading))
        .subscribe((res) => {
          if (res !== true) {
            this.loadingSubject.next(false);
            if (this.subscriptions.find((sub) => sub.id === 5) === undefined) {
              const errorStateSubscription = this.store
                .pipe(select(selectErrorState))
                .subscribe((error) => {
                  if (error) {
                    if (error.error && error.error.errors) {
                      this.submissionErrorObj = error.error.errors;
                    } else {
                      this.submissionErrorObj = [{ error: 'GLOBAL.UNSPECIFIED_ERROR' }];
                    }
                    this.hasSubmissionErrors = true;
                  } else if (this.router.routerState.snapshot.url !== '/lists/doctors') {
                    this.submissionErrorObj = null;
                    this.hasSubmissionErrors = false;
                    const message = this.translate.instant('DOCTOR.ADDED');
                    this.layoutUtilsService.showActionNotification(
                      message,
                      MessageType.Create,
                      3000,
                      false,
                      false,
                    );
                    this.goBack();
                  }
                });
              this.subscriptions.push({ id: 5, sub: errorStateSubscription });
            }
          }
          this.cdr.detectChanges();
        });
      setTimeout(
        () =>
          this.store.pipe(select(selectLastCreatedDoctor), take(1)).subscribe((val) => {
            if (!val) {
              return;
            }
            this.doctor = val;
            this.updateDoctorImage(() => {
              const editedDoctor = this.prepareDoctor();
              if (editedDoctor.id > 0) {
                this.updateDoctor(editedDoctor);
                return;
              }

              return null;
            });
          }),
        500,
      );
      this.subscriptions.push({ id: 4, sub: actionLoadingSubscription });
    }
  }

  updateDoctor(_doctor: Doctor) {
    this.loadingSubject.next(true);

    const updateDoctor: Update<Doctor> = {
      id: _doctor.id,
      changes: _doctor,
    };

    this.store.dispatch(
      new DoctorOnServerUpdated({
        partialDoctor: updateDoctor,
        doctor: _doctor,
      }),
    );
    if (this.subscriptions.find((sub) => sub.id === 6) === undefined) {
      const actionLoadingSubscription = this.store
        .pipe(select(selectDoctorsActionLoading))
        .subscribe((res) => {
          if (res !== true) {
            this.loadingSubject.next(false);
            this.store.pipe(select(selectErrorState)).subscribe((error) => {
              if (error) {
                if (error.error && error.error.errors) {
                  this.submissionErrorObj = error.error.errors;
                } else {
                  this.submissionErrorObj = [{ error: 'GLOBAL.UNSPECIFIED_ERROR' }];
                }
                this.hasSubmissionErrors = true;
              } else if (this.router.routerState.snapshot.url !== '/lists/doctors') {
                let message = '';
                if (!this.needToChangeImage) {
                  message = this.translate.instant('DOCTOR.UPDATED');
                  this.layoutUtilsService.showActionNotification(
                    message,
                    MessageType.Update,
                    3000,
                    false,
                    false,
                  );
                  this.goBack();
                } else {
                  this.globalService
                    .getEntitiesById('doctors', this.doctor.id)
                    .subscribe((doctor) => {
                      if (doctor) {
                        this.needToChangeImage = false;
                        this.loadDoctor(doctor.data);
                        this.loadTags();
                        message = 'Doctor picture changed successfully';
                        this.layoutUtilsService.showActionNotification(
                          message,
                          MessageType.Update,
                          3000,
                          false,
                          false,
                        );
                        this.cdr.detectChanges();
                        return;
                      }
                    });
                }
              }
            });
          }
          this.cdr.detectChanges();
        });
      this.subscriptions.push({ id: 6, sub: actionLoadingSubscription });
    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.doctorForm ? this.doctorForm.controls[controlName] : null;
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  onAlertClose() {
    this.hasFormErrors = false;
  }

  getStatusString(): string {
    switch (this.doctorForm.get('is_active').value) {
      case true:
        return this.translate.instant('GLOBAL.ACTIVE');
      case false:
        return this.translate.instant('GLOBAL.INACTIVE');
    }
    return '';
  }

  onOfficeChange(val) {
    this.doctorForm.controls.office_id.setValue(val);
    this.doctorForm.controls.office_id.updateValueAndValidity();
  }

  editDoctor(id) {
    this.navigationService.navigateTo('lists/doctors/edit/' + id);
  }

  putDash(e) {
    let x = e;
    if (x.length === 6 && x.charAt(5) !== '-') {
      x = x.slice(0, 5) + '-' + x.charAt(x.length - 1);
    }
    return x;
  }

  onSpecialtiesChange(val) {
    this.doctorForm.controls.specialties.setValue(val);
    this.doctorForm.controls.specialties.updateValueAndValidity();
    let parentsIds = '';
    const parents = uniqWith(this.doctorForm.controls.specialties.value, isEqual);
    parents.forEach((parent) => (parentsIds = parentsIds + '&parent=' + parent.parent));
    this.subspecialitiesAutocompleteCall = this.specialtyService.searchProviderTypes.bind(
      this.specialtyService,
      parentsIds + '&primary=false',
    );
  }

  onSubspecialitiesChange(val) {
    this.doctorForm.controls.subspecialities.setValue(val);
    this.doctorForm.controls.subspecialities.updateValueAndValidity();
  }

  displaySpecialties(val) {
    let res = '';
    if (val) {
      res += val.description;
    }
    return res;
  }

  formatNewSpecialtiesFn(val) {
    return val;
  }

  selectPatientsTab(): void {
    setTimeout(() => this.changeTab(2), 500);
  }

  updateProfile() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '600px';
    dialogConfig.height = '400px';
    const defaultImage = this.doctor.gender
      ? this.doctor.gender === 'FEMALE'
        ? this.doctorFemaleDefault
        : this.doctorMaleDefault
      : this.doctorUndefinedDefault;
    if (this.doctor.id) {
      this.globalService.getEntitiesById('doctors', this.doctor.id).subscribe((doctor) => {
        if (doctor?.data) {
          dialogConfig.data = {
            existImage: doctor?.data?.pre_signed_url?.url,
            mode: 'UPDATE',
            defaultImage,
          };
          const dialogRef = this.dialog.open(PictureCropperComponent, dialogConfig);
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              switch (result.mode) {
                case 'DELETE': {
                  this.needToChangeImage = true;
                  const editedDoctor = this.prepareDoctor();
                  editedDoctor.avatar = null;
                  if (editedDoctor.id > 0) {
                    this.updateDoctor(editedDoctor);
                    return;
                  }
                  break;
                }
                case 'UPDATE': {
                  if (result.img) {
                    this.newAvatar = this.imageSettingService.dataURLtoFile(result.img, 'fileName');
                    this.needToChangeImage = true;
                    const reader = new FileReader();
                    reader.readAsDataURL(this.newAvatar);
                    reader.onloadend = () => {
                      this.basicInfo.avatar = reader.result;
                      this.cdr.detectChanges();
                    };
                    let editedDoctor = this.prepareDoctor();
                    if (editedDoctor.id > 0) {
                      this.updateDoctorImage(() => {
                        editedDoctor = this.prepareDoctor();
                        if (editedDoctor.id > 0) {
                          this.updateDoctor(editedDoctor);
                          return;
                        }
                        return null;
                      });
                      return;
                    }
                  }
                  break;
                }
              }
            }
          });
        }
      });
    } else {
      dialogConfig.data = { existImage: null, mode: 'UPDATE', defaultImage };
      const dialogRef = this.dialog.open(PictureCropperComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          switch (result.mode) {
            case 'UPDATE': {
              if (result.img) {
                this.newAvatar = this.imageSettingService.dataURLtoFile(result.img, 'fileName');
                this.doctorProfile = result.img;
                this.needToChangeImage = true;
                const reader = new FileReader();
                reader.readAsDataURL(this.newAvatar);
                reader.onloadend = () => {
                  this.basicInfo.avatar = reader.result;
                  this.cdr.detectChanges();
                };
              }
              break;
            }
          }
        }
      });
    }
  }

  private updateDoctorImage(cc) {
    if (this.needToChangeImage) {
      return this.doctorService
        .updateDoctorImage(this.newAvatar, this.doctor.id)
        .subscribe((res2) => {
          this.doctorService.uploadDoctorImage(res2, this.newAvatar).subscribe(() => {
            this.basicInfo.avatarUUID = res2.data.uuid;
            cc();
          });
        });
    } else {
      cc();
    }
  }

  firstLine() {
    const titleOne = document.querySelector('.title-one') as HTMLElement;
    const text =
      (this.doctor.first_name ? this.doctor.first_name : '') +
      ' ' +
      (this.doctor.middle_name ? this.doctor.middle_name : '');
    const textLength = text.length;
    const fontSize = Math.floor(220 / textLength);
    const newSize = (fontSize + 5) * 8 - 15;
    titleOne.style.fontSize = textLength < 16 ? 20 + 'px' : newSize + '%';
    return text;
  }

  secondLine() {
    const titleTwo = document.querySelector('.title-two') as HTMLElement;
    const text2 =
      (this.doctor.last_name ? this.doctor.last_name : '') +
      ' ' +
      (this.doctor.last_name2 ? this.doctor.last_name2 : '');
    const textLength2 = text2.length;
    const fontSize2 = Math.floor(220 / textLength2);
    const newSize2 = (fontSize2 + 5) * 8 - 15;
    titleTwo.style.fontSize = textLength2 < 16 ? 20 + 'px' : newSize2 + '%';
    return text2;
  }
  addressLine(type?) {
    const tooltip =
      (this.doctor?.address_1 ? this.titleCasePipe.transform(this.doctor.address_1) + ', ' : '') +
      (this.doctor?.address_2 ? this.titleCasePipe.transform(this.doctor.address_2) + ', ' : '') +
      (this.doctor?.city ? this.titleCasePipe.transform(this.doctor.city) + ', ' : '') +
      (this.doctor?.state ? this.doctor.state + ' ' : '') +
      (this.doctor?.zip ? this.doctor.zip : '');
    const title =
      (this.doctor?.city ? this.titleCasePipe.transform(this.doctor.city) + ', ' : '') +
      (this.doctor?.state ? this.doctor.state + ' ' : '') +
      (this.doctor?.zip ? this.doctor.zip : '');
    return type === 'tooltip' ? tooltip : title;
  }
  changeTab(index) {
    this.tabs = this.tabs.map((item) => {
      item.active = item.index === index;
      return item;
    });
    this.insertParam(index);
  }

  insertParam(value) {
    if (this.fromCanvas) return;
    const queryParams = { tab_index: +value };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
      queryParamsHandling: 'merge',
    });
  }
  showDoctorPhoto(doctor) {
    if (!this.doctor.pre_signed_url?.url) {
      return;
    }
    this.dialog.open(ZoomInEntityComponent, { data: { entity: doctor }, maxWidth: '600px' });
  }
}
